import { z } from "zod";

export const serverResponse = z.object({
  action_token: z.string(),
});
